import React, { useEffect } from 'react'
import Marketo from '../components/global/marketo'

// Constants
import { navigate } from 'gatsby'
import { Wechat_QRCode } from '../components/global/newFooter/utils/footerLogos'
import Typography from '../components/global/typography'
import WrapperImage from '../components/global/wrapperImage'
import { LocaleCodes } from '../constants/localization.constants'
import { correctSlugPrefix } from './link.utils'

// CN Legals URLs
export const CNPrivacyPolicyURL = 'https://www.uipath.com.cn/legal/privacy-policy/'
export const CNWebinarTermURL =
  'https://www.uipath.com.cn/wp-content/uploads/pdf/legal/Event-Webinar-Terms-and-Conditions-CN.pdf'

export const renderMarketoOrIframe = ({
  defaultLocale,
  marketoFormData,
  formSuccessHandler,
  marketoJsScript,
  cnFormOverride,
}: any) => {
  return defaultLocale !== LocaleCodes.CHINESE.code ? (
    <Marketo
      formData={marketoFormData && marketoFormData.marketoForm}
      formCallbacks={formSuccessHandler}
      marketoJsScript={marketoJsScript}
    />
  ) : (
    <iframe width="100%" height="1220" src={cnFormOverride} frameBorder="0" />
  )
}

export const cnOverrideForm = (data: string) => {
  useEffect(() => {
    const cnOverrideFormThankYou = () => {
      navigate(correctSlugPrefix(data))
    }
    window.cnOverrideFormThankYou = cnOverrideFormThankYou
  }, [data])
}

export const cnPrivacyPolicy = () => {
  useEffect(() => {
    const goPrivacyPolicy = () => {
      window.open(CNPrivacyPolicyURL, '_blank', 'noopener')
    }
    window.goPrivacyPolicy = goPrivacyPolicy
  }, [CNPrivacyPolicyURL])
}

export const cnWebinarTerms = () => {
  useEffect(() => {
    const goWebinarTerms = () => {
      window.open(CNWebinarTermURL, '_blank', 'noopener')
    }
    window.goWebinarTerms = goWebinarTerms
  }, [CNWebinarTermURL])
}

export const cnWeChatPopOver = (e: any) => {
  const WeChatToggle = document.querySelector('a[data-target]')
  const WeChatPopup = document.getElementById('popover_wechat')
  if (WeChatToggle && WeChatPopup) {
    WeChatPopup.classList.toggle('open')
    const top = WeChatToggle.offsetTop - (WeChatPopup?.clientHeight + 15)
    const left = WeChatToggle.offsetLeft - WeChatPopup?.clientWidth / 2 + 12

    if (typeof window && window.innerWidth > 767) {
      WeChatPopup.style.top = top + 'px'
      WeChatPopup.style.left = left + 'px'
    }
  }
}

export const WeChatPopUp = () => {
  return (
    <div id="popover_wechat" className="popover" role="tooltip">
      <div className="parrow"></div>
      <div className="popover-body">
        <div className="qr-img">
          <WrapperImage src={Wechat_QRCode} />
        </div>

        <div className="qrcode-section">
          <div className="wc-qr-desktop">
            <Typography type="bodyXS">使用微信扫描二维码关注我们</Typography>
          </div>
          <div className="wc-qr-tablet">
            <Typography type="bodyXS">使用微信扫描二维码关注我们</Typography>
            <Typography type="bodyXS">
              或者在微信中搜索公众号 <a href="https://www.uipath.com.cn/">UiPathChina</a>
            </Typography>
          </div>
          <div className="wc-qr-mobile">
            <Typography type="bodyXS">
              长按二维码保存至相册，打开微信识别二维码关注我们。
            </Typography>
            <Typography type="bodyXS">
              在微信中搜索公众号 <a href="https://www.uipath.com.cn/">UiPathChina</a>
              ，同样能找到我们。
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export const tencentVideoPlay = (videoUrl: string) => {
  let tencentVideoPlayer = document.getElementById('tencentVideoPlayer')
  if (tencentVideoPlayer) {
    if (Hls.isSupported()) {
      let hls = new Hls()
      hls.loadSource(videoUrl)
      hls.attachMedia(tencentVideoPlayer)
      hls.on(Hls?.Events?.MANIFEST_PARSED, function () {
        tencentVideoPlayer.play()
      })
    } else if (tencentVideoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
      tencentVideoPlayer.src = videoUrl
      tencentVideoPlayer.addEventListener('canplay', function () {
        tencentVideoPlayer.play()
      })
    }
  }
}
